// extracted by mini-css-extract-plugin
export var layoutContainer = "_3v-0";
export var layoutContainerNoRounding = "_3v-6";
export var layoutContainerOpen = "_3v-5";
export var layoutContainerResizing = "_3v-1";
export var mainContent = "_3v-2";
export var resizeDivider = "_3v-3";
export var slidePanel = "_3v-4";